// extracted by mini-css-extract-plugin
export default {"cls1":"UzQHvNHkcrh05z16Nowj","cls2":"XWQnGtREsaAKYrJoIkWC UzQHvNHkcrh05z16Nowj"};